import { FormControlLabel, Radio, RadioGroup, Stack, Typography } from '@mui/material';
import { AccessEventsFilter } from 'graphql/generated/graphqlTypes';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React, { useState } from 'react';
import ModalTemplate from 'v2/components/Modal/ModalTemplate';
import useModalContext from 'v2/components/Modal/useModalContext';
import PreparingExportModal from './PreparingExportModal';

interface Props {
  filter: AccessEventsFilter | null;
}

const ExportModal: React.FC<Props> = ({ filter }) => {
  const { translation } = useTranslation();
  const { openModal } = useModalContext();
  const [useFiltered, setUseFiltered] = useState(true);

  const handleExport = () => openModal(<PreparingExportModal filter={useFiltered ? filter : null} />);

  return (
    <ModalTemplate
      title={translation.create_export}
      primaryAction={{ id: 'export-button', label: translation.export, onClick: handleExport }}
    >
      <Stack spacing={2}>
        <Typography variant="body2">
          {
            translation.please_note_that_one_or_more_filters_have_been_applied_to_the_access_events_only_the_results_matching_these_filters_will_be_included_in_the_export
          }
        </Typography>
        <RadioGroup value={useFiltered ? 'filtered' : 'all'} onChange={(_, val) => setUseFiltered(val === 'filtered')}>
          <FormControlLabel
            value="filtered"
            control={<Radio id="export-filtered-events-radio" />}
            label={translation.export_filtered_events_only}
          />
          <FormControlLabel
            value="all"
            control={<Radio id="export-all-events-radio" />}
            label={translation.export_all_events}
          />
        </RadioGroup>
      </Stack>
    </ModalTemplate>
  );
};

export default ExportModal;
